import Image from 'next/image';

const CATEGORY_ICONS: any = {
  Relleno: {
    src: 'rellenos.svg',
  },
  'Calidad Piel': {
    src: 'calidad-piel.svg',
  },
  Arrugas: {
    src: 'arrugas.svg',
  },
  'Caida del pelo': {
    src: 'caida-pelo.svg',
  },
  Lifting: {
    src: 'lifting.svg',
  },
  'Inductores de colágeno': {
    src: 'lifting.svg',
  },
  Otros: {
    src: 'otros.svg',
  },
  Médico: {
    src: 'otros.svg',
  },
  Packs: {
    src: 'pack.svg',
  },
  'Probador Virtual': {
    src: 'pack.svg',
  },
  'Higiene facial': {
    src: 'beauty.svg',
  },
  'Tratamientos Belleza': {
    src: 'belleza.svg',
  },
  Revitalizante: {
    src: 'skin-firming.svg',
  },
  Regenerador: {
    src: 'skin-protection.svg',
  },
  Longevidad: {
    src: 'longevidad.svg',
  },
  IPL: {
    src: 'ipl.svg',
  },
  Corporal: {
    src: 'corporal.svg',
  },
};

export default function CategoryIcon({ category }: { category: string }) {
  if (!CATEGORY_ICONS[category]?.src) {
    return <></>;
  }

  return (
    <Image
      src={`/images/filters/categories/${CATEGORY_ICONS[category].src}`}
      width={33}
      height={33}
      alt={category}
      className="shrink-0 mr-2"
    />
  );
}
